export const bagIsEmpty = 'Your Bag is Empty!';
export const bagEmptyDescription = 'You have products in your Wishlist waiting to be yours';
